var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscardedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C2.25 0.5 0 2.75 0 5.5C0 8.25 2.25 10.5 5 10.5C7.75 10.5 10 8.25 10 5.5C10 2.75 7.75 0.5 5 0.5ZM6.98875 6.605C7.11063 6.72687 7.11063 6.925 6.98875 7.04688L6.54688 7.48875C6.425 7.61063 6.22687 7.61063 6.105 7.48875L5 6.38375L3.895 7.48875C3.77312 7.61063 3.575 7.61063 3.45312 7.48875L3.01125 7.04688C2.88937 6.925 2.88937 6.72687 3.01125 6.605L4.11625 5.5L3.01125 4.395C2.88937 4.27312 2.88937 4.075 3.01125 3.95312L3.45312 3.51125C3.575 3.38937 3.77312 3.38937 3.895 3.51125L5 4.61625L6.105 3.51125C6.22687 3.38937 6.425 3.38937 6.54688 3.51125L6.98875 3.95312C7.11063 4.075 7.11063 4.27312 6.98875 4.395L5.88375 5.5L6.98875 6.605Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardedIcon);
export default __webpack_public_path__ + "static/media/discardedIcon.bbe7f411430225400b778fb896621328.svg";
export { ForwardRef as ReactComponent };